import Modal from 'bootstrap/js/src/modal'
import Cookies from 'js-cookie'

(function ($){
    $(document).ready(function () {
        const modalSelector = '#tablet-info-modal'
        const modalCookieName = 'tablet-modal-shown'
        const cookieTimeExpiration = 30
        const isModalShowed = Cookies.get(modalCookieName)

        if ( isModalShowed === '1' || document.querySelector(modalSelector) === null ) {
            return
        }

        const myModal = new Modal(modalSelector, {
            keyboard: false
        })

        setTimeout(() => {
            myModal.show()

            Cookies.set(modalCookieName, '1', {
                expires: cookieTimeExpiration
            })
        }, 900)
    })
})(jQuery)